import {
  people01,
  people02,
  people03,
  facebook,
  instagram,
  linkedin,
  yt,
  send,
  shield,
  star,
  menu,
  close,
  logo,
} from "../images/landingPage";

// General Navigation Links for LandingPage
export const navLinks = [
  { id: "hjem", name: "Hjem", link: "/" },
  { id: "blog", name: "Blog", link: "/blog" },
];

export const authLinks = [
  { id: "logind", name: "Log ind", link: "/signin" },
  { id: "opretbruger", name: "Opret bruger", link: "/signup" },
];

// Features Data
export const features = [
  {
    id: "feature-1",
    icon: star,
    title: "Intelligent Aktieanalyse",
    content:
      "Vores intuitive værktøj gør det enkelt at analysere aktier baseret på dine fremtidsforventninger. Beregn potentielle kursmål uden kompleks matematik.",
  },
  {
    id: "feature-2",
    icon: shield,
    title: "Premium Finansdata",
    content:
      "Få adgang til nøje kurateret markedsdata via vores premium API. Udforsk aktier fra mere end 70 børser fra hele verden, og find din næste investeringsmulighed.",
  },
  {
    id: "feature-3",
    icon: send,
    title: "Aktivt Investorforum",
    content:
      "Del viden og indsigt i vores dedikerede investorforum. Udvid din forståelse gennem dialog med erfarne investorer.",
  },
  {
    id: "feature-4",
    icon: shield,
    title: "AI-drevet Fundamentalanalyse",
    content:
      "Få det komplette overblik over globale børsmarkeder gennem vores strømlinede analyseplatform. Vi har forenklet processen for fundamentalanalyse, så du kan træffe bedre investeringsbeslutninger hurtigere og mere effektivt.",
  },
  {
    id: "feature-5",
    icon: send,
    title: "Internationalt Nyhedsfeed",
    content:
      "Få øjeblikkelig adgang til finansnyheder fra internationale markeder. Vores nyhedsintegration sikrer, at du aldrig misser vigtige investeringsmuligheder - uanset hvor i verden de opstår.",
  },
];

// Feedback Data
export const feedback = [
  {
    id: "feedback-2",
    content:
      "Fundamental investering handler om at forstå virksomheders sande værdi. Med IV's platform får du det komplette overblik og den dybdegående indsigt, der er nødvendig for at træffe kvalificerede investeringsbeslutninger.",
    img: people02,
    name: "Magnus Kongshammer",
    title: "Grundlægger og platformudvikler",
  },
 
];

// Statistics Data
export const stats = [
  {
    id: "stats-1",
    title: "Aktieanalyser",
    value: "200.000+",
  },
  {
    id: "stats-2",
    title: "Børser Verden Over",
    value: "70+",
  },
  {
    id: "stats-3",
    title: "Rationel, Informativ Investeringsværktøj",
    value: "100%",
  },
];

// Footer Links
export const footerLinks = [
  {
    title: "Brugbare Links",
    links: [
      {
        name: "Indhold",
        link: "/indhold",
      },
      {
        name: "Hvordan fungerer det",
        link: "/hvordan-fungerer-det",
      },
      {
        name: "Vilkår & Betingelser",
        link: "/terms-and-policy",
      },
    ],
  },
  {
    title: "Fællesskab",
    links: [
      {
        name: "Blog",
        link: "/blog",
      },
      {
        name: "Bliv IV Partner",
        link: "/ivpartner",
      },
    ],
  },
];

// Social Media Links
export const socialMedia = [
  {
    id: "social-media-1",
    icon: instagram,
    link: "https://www.instagram.com/investorverden/",
  },
  {
    id: "social-media-2",
    icon: facebook,
    link: "https://www.facebook.com/profile.php?id=61570577011530&locale=da_DK",
  },
  {
    id: "social-media-3",
    icon: linkedin,
    link: "https://www.linkedin.com/company/investorverden/",
  },
  {
    id: "social-media-4",
    icon: yt,
    link: "https://www.youtube.com/channel/UC7Xh9PWFGiF7SmrTE87t34g",
  },
];

// Clients Data (Currently Empty)
export const clients = [];

// Years of Analysis
// ...existing code...
export const yearsOfAnalysis = Array.from({ length: 10 }, (_, index) => ({
  id: index + 1,
  name: `${index + 1} år`
}));